import { useTranslation } from 'react-i18next';
import ReactApexChart from 'react-apexcharts';
import { useSetState } from 'react-use';
import MainCard from './MainCard';
import { Grid, Typography } from '@ts/storybook';
import _ from 'lodash';

const ColumnsWithNegativeChart = props => {
  const { t } = useTranslation();

  const [state, setState] = useSetState({
    series: [
      {
        name: 'Time in Production Zone',
        data: [
          1.45, 5.42, 5.9, -0.42, -12.6, -8.1, -18.2, -44.16, -1.1, -6.09, 0.34, 3.88, 3.07, 5.8, 2, 7.37, 8.1, 13.57, 1.75, 1.1,
          2.8, -10.03, -5.4, -7.2, -4.3, -10.6, -28.6, -11.1, -19.6, -37.6, -29.4, -2.4, -2.4,
        ],
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          colors: {
            ranges: [
              {
                from: -100,
                to: -46,
                color: '#F15B46',
              },
              {
                from: -45,
                to: 0,
                color: '#FEB019',
              },
            ],
          },
          columnWidth: '80%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      yaxis: {
        title: {
          text: 'Cummulated time',
        },
        labels: {
          formatter: function (y) {
            return y.toFixed(0) + '%';
          },
        },
      },
      xaxis: {
        type: 'datetime',
        categories: [
          '2011-01-01',
          '2011-02-01',
          '2011-03-01',
          '2011-04-01',
          '2011-05-01',
          '2011-06-01',
          '2011-07-01',
          '2011-08-01',
          '2011-09-01',
          '2011-10-01',
          '2011-11-01',
          '2011-12-01',
          '2012-01-01',
          '2012-02-01',
          '2012-03-01',
          '2012-04-01',
          '2012-05-01',
          '2012-06-01',
          '2012-07-01',
          '2012-08-01',
          '2012-09-01',
          '2012-10-01',
          '2012-11-01',
          '2012-12-01',
          '2013-01-01',
          '2013-02-01',
          '2013-03-01',
          '2013-04-01',
          '2013-05-01',
          '2013-06-01',
          '2013-07-01',
          '2013-08-01',
          '2013-09-01',
        ],
        labels: {
          rotate: -90,
        },
      },
    },
  });

  return (
    <MainCard contentSX={{ p: 2.25 }}>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid mb={1.5}>{props.title && <Typography variant="h5" fontWeight="500" color="primary" text={props.title} />}</Grid>
      </Grid>
      <div style={{ overflow: 'auto', position: 'relative' }}>
        <div style={{ minWidth: '100%', minHeight: '502px' }}>
          {/* @ts-ignore */}
          <ReactApexChart options={state.options} series={state.series} type="bar" height={470} />
        </div>
      </div>
    </MainCard>
  );
};

export default ColumnsWithNegativeChart;
